import styled from 'styled-components';

export const SidebarContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding-bottom: 18px;
  .header {
    padding: 18px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 22px;
    font-weight: 700;
    color: #09305a;
  }
  .options {
    display: flex;
    flex-direction: column;

    .option-container {
      padding-left: 18px;
      background-color: #fff;
      padding-top: 9px;
      padding-bottom: 9px;
      cursor: pointer;

      .option {
        display: flex;
        flex-direction: row;
        align-items: center;
        column-gap: 10px;

        .label {
          font-size: 14.5px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          color: #09305a;
        }
      }
    }

    .selected {
      background-color: #e5f2ff;
    }
  }
`;
